import Environment from '../../../Environment';
import { IFilter, buildUrl } from '../../BaseService';

export interface IPrepareTranslationUrl {
  filters?: IFilter[];
}

export function prepareTranslationUrl({
  filters,
}: IPrepareTranslationUrl): string {
  return buildUrl({
    host: Environment.bibleService,
    resource: 'translation',
    filters,
  });
}
